import React from "react";
import "../Styles/Footer.css";
import socials from "../contents/socials";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo-placeholder"></div>
        <nav className="footer-nav">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/blogs">Blogs</NavLink>
          <NavLink to="/aboutus">About</NavLink>
          <NavLink to="/contactus">Contact</NavLink>
        </nav>
      </div>
      <hr className="footer-divider" />
      <div className="footer-bottom">
        <p></p>
        <div className="footer-social">
          {socials.map(({ id, icon: Icon, image, link }) => (
            <a key={id} href={link} target="_blank" rel="noopener noreferrer">
              {Icon ? <Icon /> : <img src={image} alt={id} />}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
